import { render } from "./HeroContainer.vue?vue&type=template&id=474f5ffe"
import script from "./HeroContainer.vue?vue&type=script&lang=js"
export * from "./HeroContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__